import React, { useEffect, useState } from "react";
import Spinner from "../../Shared/Feature/LoadingSpinner/Spinner";
import axios from "axios";
import ipconfig from "../../Core/ipconfig";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useTheme,
  ListItemAvatar,
  Avatar,
  Slide,
  Paper,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DevicesIcon from "@mui/icons-material/Devices";
import PersonIcon from "@mui/icons-material/Person";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import StorageIcon from "@mui/icons-material/Storage";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
import SyncIcon from "@mui/icons-material/Sync";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { formatPhoneNumber } from "../../Core/util/formatPhone";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CompantDetailes({ data }: any) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [companyData, setCompanyData] = useState<any>({});
  const [companyDetails, setCompanyDetails] = useState<any>({});
  const [userBackup, setUserBackup] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState<any>(true);

  const handleClickOpen = (id: any) => {
    setOpen(true);
    getCompanyDetails(id);
  };

  const handleClose = () => {
    setOpen(false);
    setCompanyDetails({});
  };

  const handleOpenDeleteModal = () => setDeleteModal(true);
  const handleCloseDeleteModal = () => setDeleteModal(false);

  const getCompanyDetails = async (companyId: any) => {
    try {
      const response = await axios.get(
        `${ipconfig}/companydetailbyid?companyId=${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setCompanyDetails(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handlegetCompanyData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${ipconfig}/fetchuserinfowithcompany?userId=${data?._id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setCompanyData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const deleteCompany = async () => {
    try {
      const response = await axios.delete(
        `${ipconfig}/company/delete?companyId=${companyDetails?._id}&userBackup=${userBackup}`,
        {
          params: {},
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.status === 200) {
        handleCloseDeleteModal();
        handleClose();
        handlegetCompanyData();
      }
    } catch (error) {
      console.log(error, "Error deleting company");
    }
  };

  useEffect(() => {
    handlegetCompanyData();
  }, [data?._id]);

  if (isLoading) {
    return <Spinner height="100%" />;
  }

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "24px" }}>
      {companyData?.tallyLicenses && companyData.tallyLicenses.length > 0 ? (
        companyData.tallyLicenses.map((items: any, index: any) => (
          <Paper
            key={index}
            variant="outlined"
            sx={{
              p: "20px",
              borderRadius: "12px",
              borderColor: "divider",
              backgroundColor: theme.palette.mode === "light" ? "background.paper" : "#1e293b30",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "16px", mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Avatar sx={{ bgcolor: "primary.main", width: "48px", height: "48px" }}>
                  <VpnKeyIcon />
                </Avatar>
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary" }}>
                      License Number: {items?.tallyLicenseNumber}
                    </Typography>
                    {items?.tallyLicenseNumber && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          navigator.clipboard.writeText(items.tallyLicenseNumber);
                          toast.success("License number copied to clipboard!", { position: "top-center", autoClose: 1000 });
                        }}
                        sx={{ p: "2px", color: "text.secondary" }}
                        title="Copy License Number"
                      >
                        <ContentCopyIcon sx={{ fontSize: "14px" }} />
                      </IconButton>
                    )}
                  </Box>

                  {items?.licenseOwnerEmail && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mt: 0.2 }}>
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {items.licenseOwnerEmail}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          navigator.clipboard.writeText(items.licenseOwnerEmail);
                          toast.success("License email copied to clipboard!", { position: "top-center", autoClose: 1000 });
                        }}
                        sx={{ p: "2px", color: "text.secondary" }}
                        title="Copy License Email"
                      >
                        <ContentCopyIcon sx={{ fontSize: "12px" }} />
                      </IconButton>
                    </Box>
                  )}

                  {items?._id && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mt: 0.2 }}>
                      <Typography variant="body2" sx={{ color: "text.secondary", fontSize: "13px" }}>
                        License ID: {items._id}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          navigator.clipboard.writeText(items._id);
                          toast.success("License ID copied to clipboard!", { position: "top-center", autoClose: 1000 });
                        }}
                        sx={{ p: "2px", color: "text.secondary" }}
                        title="Copy License ID"
                      >
                        <ContentCopyIcon sx={{ fontSize: "12px" }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Box>
              <Chip
                label={items?.accosyncoptedservice?.isOnFreeTrial ? `Plan: Free Trial` : `Accosync Plan: ${items?.accosyncoptedservice?.name || "No Plan"}`}
                color="primary"
                variant="outlined"
                sx={{ fontWeight: 650, borderRadius: "8px" }}
              />
            </Box>

            <Grid container spacing={2} sx={{ mb: 4 }}>
              {[
                { label: "Purchase Date", value: items?.accosyncoptedservice?.subscriptionTimestamp ? moment(items?.accosyncoptedservice?.subscriptionTimestamp).format("DD-MM-YYYY hh:mm A") : "N/A", icon: <CalendarTodayIcon sx={{ fontSize: 18 }} /> },
                { label: "Valid Till", value: items?.accosyncoptedservice?.expiryTimestamp ? moment(items?.accosyncoptedservice?.expiryTimestamp).format("DD-MM-YYYY hh:mm A") : "N/A", icon: <CalendarTodayIcon sx={{ fontSize: 18 }} /> },
                { label: "Purchased Devices", value: items?.accosyncoptedservice?.allowedUserAndDevices || "0", icon: <DevicesIcon sx={{ fontSize: 18 }} /> },
                { label: "Synced Companies", value: items?.companies?.length || "0", icon: <StorageIcon sx={{ fontSize: 18 }} /> },
                { label: "Connectors Count", value: items?.connectors?.length || "0", icon: <SettingsInputComponentIcon sx={{ fontSize: 18 }} /> },
              ].map((spec, sIdx) => (
                <Grid item xs={12} sm={6} md={2.4} key={sIdx}>
                  <Box sx={{ p: "12px", borderRadius: "8px", border: "1px solid", borderColor: "divider", height: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "6px", color: "text.secondary", mb: 0.5 }}>
                      {spec.icon}
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {spec.label}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "text.primary" }}>
                      {spec.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Divider sx={{ mb: 3 }} />

            {/* Companies list */}
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "text.primary" }}>
              Companies synced under this license
            </Typography>

            {items?.companies && items.companies.length > 0 ? (
              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "16px" }}>
                {items.companies.map((company: any, cIdx: any) => {
                  const isDemo = company?.companyName === "democompany_787313664_7504884137";
                  return (
                    <Card
                      key={cIdx}
                      variant="outlined"
                      onClick={isDemo ? undefined : () => handleClickOpen(company?._id)}
                      sx={{
                        borderRadius: "10px",
                        borderColor: "divider",
                        cursor: isDemo ? "default" : "pointer",
                        "&:hover": isDemo ? {} : {
                          borderColor: "primary.main",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.04)"
                        },
                        transition: "all 0.2s ease"
                      }}
                    >
                      <CardContent sx={{ p: "16px !important", display: "flex", flexDirection: "column", gap: "12px" }}>
                        <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: "4px" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "text.primary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flexGrow: 1 }}>
                              {company?.companyInfo?.Name || (company?.companyName && typeof company.companyName === "string" ? company.companyName.split("_")[0] : "Unnamed Company")}
                            </Typography>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                const name = company?.companyInfo?.Name || (company?.companyName && typeof company.companyName === "string" ? company.companyName.split("_")[0] : "Unnamed Company");
                                navigator.clipboard.writeText(name);
                                toast.success("Company Name copied to clipboard!", { position: "top-center", autoClose: 1000 });
                              }}
                              sx={{ p: "2px", color: "text.secondary" }}
                              title="Copy Company Name"
                            >
                              <ContentCopyIcon sx={{ fontSize: "12px" }} />
                            </IconButton>
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                              DB: {company?.dbName || "N/A"}
                            </Typography>
                            {company?.dbName && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(company.dbName);
                                  toast.success("DB Name copied to clipboard!", { position: "top-center", autoClose: 1000 });
                                }}
                                sx={{ p: "2px", color: "text.secondary" }}
                                title="Copy DB Name"
                              >
                                <ContentCopyIcon sx={{ fontSize: "10px" }} />
                              </IconButton>
                            )}
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                              Company ID: {company?._id || "N/A"}
                            </Typography>
                            {company?._id && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigator.clipboard.writeText(company._id);
                                  toast.success("Company ID copied to clipboard!", { position: "top-center", autoClose: 1000 });
                                }}
                                sx={{ p: "2px", color: "text.secondary" }}
                                title="Copy Company ID"
                              >
                                <ContentCopyIcon sx={{ fontSize: "10px" }} />
                              </IconButton>
                            )}
                          </Box>
                        </Box>

                        <Divider />

                        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", color: "text.secondary" }}>
                              <SyncIcon sx={{ fontSize: 16 }} />
                              <Typography variant="caption">Synced State</Typography>
                            </Box>
                            <Chip
                              label={company?.syncData ? "On" : "Off"}
                              size="small"
                              color={company?.syncData ? "success" : "default"}
                              sx={{ fontWeight: 700, height: "18px", fontSize: "10px" }}
                            />
                          </Box>

                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", color: "text.secondary" }}>
                              <SystemUpdateAltIcon sx={{ fontSize: 16 }} />
                              <Typography variant="caption">Import Voucher</Typography>
                            </Box>
                            <Chip
                              label={company?.autoImportVoucher ? "On" : "Off"}
                              size="small"
                              color={company?.autoImportVoucher ? "success" : "default"}
                              sx={{ fontWeight: 700, height: "18px", fontSize: "10px" }}
                            />
                          </Box>
                        </Box>

                        <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <Typography variant="caption" sx={{ color: "text.secondary" }}>
                            Last Synced:
                          </Typography>
                          <Typography variant="caption" sx={{ fontWeight: 600, color: "text.primary" }}>
                            {company?.lastSyncedTime ? moment(company.lastSyncedTime).format("DD-MM-YYYY hh:mm A") : "N/A"}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
            ) : (
              <Box sx={{ p: 3, border: "1px dashed", borderColor: "divider", borderRadius: "8px", textAlign: "center" }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  No companies synchronized.
                </Typography>
              </Box>
            )}
          </Paper>
        ))
      ) : (
        <Box sx={{ p: 6, border: "1px dashed", borderColor: "divider", borderRadius: "12px", textAlign: "center" }}>
          <Typography variant="body1" sx={{ color: "text.secondary", fontWeight: 500 }}>
            No licenses found for this user.
          </Typography>
        </Box>
      )}

      {/* Full screen dialog for company info */}
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative", boxShadow: "none", borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.paper", color: "text.primary" }}>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Company Details: {companyDetails?.tally_companyInfo?.Name || "Loading..."}
              </Typography>
            </Box>
            <Button
              variant="outlined"
              color="error"
              startIcon={<DeleteIcon />}
              onClick={handleOpenDeleteModal}
              sx={{ textTransform: "none", fontWeight: 600 }}
            >
              Delete Company
            </Button>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: "24px", display: "flex", flexDirection: "column", gap: "24px", overflowY: "auto", height: "100%" }}>
          <Paper variant="outlined" sx={{ p: "20px", borderRadius: "12px" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "text.primary" }}>
              General Information
            </Typography>
            <Grid container spacing={3}>
              {[
                { label: "Company Name", value: companyDetails?.tally_companyInfo?.Name },
                { label: "Database Name", value: companyDetails?.dbName || "N/A" },
                { label: "Import Voucher status", value: companyDetails?.autoImportVoucher ? "Enabled" : "Disabled" },
                { label: "Synced Data status", value: companyDetails?.syncData ? "Enabled" : "Disabled" },
                { label: "Synced By User Email", value: companyDetails?.syncedByUserId?.email || "N/A" },
                { label: "Synced By User Name", value: companyDetails?.syncedByUserId?.name || "N/A" },
                { label: "Synced By User Phone", value: formatPhoneNumber(companyDetails?.syncedByUserId?.phoneNumber, companyDetails?.syncedByUserId?.countryCode) },
              ].map((item, idx) => (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                    {item.label}
                  </Typography>
                  <Typography sx={{ fontWeight: 600, color: "text.primary" }}>
                    {item.value}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Paper>

          <Grid container spacing={3}>
            {/* Devices list panel */}
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: "20px", borderRadius: "12px", height: "100%", display: "flex", flexDirection: "column" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "text.primary", display: "flex", alignItems: "center", gap: "8px" }}>
                  <DevicesIcon color="primary" />
                  Devices List ({companyDetails?.devices?.length || 0})
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <List sx={{ flexGrow: 1, overflowY: "auto", maxOffsetHeight: "350px" }}>
                  {companyDetails?.devices?.length > 0 ? (
                    companyDetails.devices.map((device: any, idx: any) => (
                      <ListItem
                        key={idx}
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: "8px",
                          mb: "12px",
                          backgroundColor: theme.palette.mode === "light" ? "#f8fafc" : "#1e293b30",
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: "primary.light", color: "primary.main" }}>
                            <DevicesIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={device?.deviceName || "Unknown Device"}
                          secondary={
                            <>
                              <Typography component="span" variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                                id: {device?._id || "N/A"}
                              </Typography>
                              <Typography component="span" variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                                Model: {device?.modelName || "N/A"}
                              </Typography>
                              <Typography component="span" variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                                Owner Email: {device?.deviceOwnerEmail || "N/A"}
                              </Typography>
                            </>
                          }
                          primaryTypographyProps={{ fontWeight: 600, fontSize: "14px" }}
                        />
                      </ListItem>
                    ))
                  ) : (
                    <Box sx={{ p: 4, textAlign: "center", color: "text.secondary" }}>
                      No devices associated.
                    </Box>
                  )}
                </List>
              </Paper>
            </Grid>

            {/* Users list panel */}
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: "20px", borderRadius: "12px", height: "100%", display: "flex", flexDirection: "column" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "text.primary", display: "flex", alignItems: "center", gap: "8px" }}>
                  <PersonIcon color="primary" />
                  Authorized Users ({companyDetails?.usersInfo?.length || 0})
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <List sx={{ flexGrow: 1, overflowY: "auto", maxOffsetHeight: "350px" }}>
                  {companyDetails?.usersInfo?.length > 0 ? (
                    companyDetails.usersInfo.map((u: any, idx: any) => {
                      const rootUser = u?.rootDbUserId;
                      return (
                        <ListItem
                          key={idx}
                          sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: "8px",
                            mb: "12px",
                            backgroundColor: theme.palette.mode === "light" ? "#f8fafc" : "#1e293b30",
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar sx={{ bgcolor: "success.light", color: "success.main" }}>
                              <PersonIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={rootUser?.name || "Unknown User"}
                            secondary={
                              <>
                                <Typography component="span" variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                                  id: {rootUser?._id || "N/A"}
                                </Typography>
                                <Typography component="span" variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                                  Email: {rootUser?.email || "N/A"}
                                </Typography>
                                <Typography component="span" variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                                  Phone: {formatPhoneNumber(rootUser?.phoneNumber, rootUser?.countryCode)}
                                </Typography>
                              </>
                            }
                            primaryTypographyProps={{ fontWeight: 600, fontSize: "14px" }}
                          />
                        </ListItem>
                      );
                    })
                  ) : (
                    <Box sx={{ p: 4, textAlign: "center", color: "text.secondary" }}>
                      No authorized users found.
                    </Box>
                  )}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      {/* Delete confirmation dialog */}
      <Dialog
        open={deleteModal}
        onClose={handleCloseDeleteModal}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          Delete Company Link
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Are you sure you want to delete this company from the user's dashboard? This action cannot be undone.
          </DialogContentText>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Checkbox
              checked={userBackup}
              onChange={(e) => setUserBackup(e.target.checked)}
              id="user-backup-checkbox"
            />
            <Typography variant="body2" component="label" htmlFor="user-backup-checkbox" sx={{ cursor: "pointer", userSelect: "none" }}>
              Include User Data Backup
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: "16px 24px" }}>
          <Button onClick={handleCloseDeleteModal} sx={{ textTransform: "none", fontWeight: 600 }}>
            Cancel
          </Button>
          <Button onClick={deleteCompany} color="error" variant="contained" sx={{ textTransform: "none", fontWeight: 600 }}>
            Delete Permanently
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer style={{ width: "auto" }} />
    </Box>
  );
}
